import React, { useState } from "react";
import Logo from "../assets/nexgenLogo.svg";
import SystemPic from "../assets/Icon.svg";
import SystemActive from "../assets/system.svg";
import AllResp from "../assets/allResponses.svg";
import AllRespActive from "../assets/allrespactive.svg";
import UserIcon from "../assets/user.svg";
import userActiveIcon from "../assets/useractive.svg";
import contactIcon from "../assets/contact.svg";
import contactActiveIcon from "../assets/contactactive.svg";
import aboutIcon from "../assets/about.svg";
import aboutActiveIcon from "../assets/aboutactive.svg";
import privacyIcon from "../assets/privacy.svg";
import privacyActiveIcon from "../assets/privacyactive.svg";
import termsIcon from "../assets/terms.svg";
import termsActiveIcon from "../assets/termsactive.svg";
import SettingPic from "../assets/setting.svg";

import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import Hamburger from "hamburger-react";
const DashboardSideBar = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activePath, setActivePath] = useState(location.pathname);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const logoutfunc = () => {
    localStorage.removeItem("authToken");
    navigate("/");
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  return (
    <div className="d-flex w-100">
      <div className={`dashboard-sidebar ${isSidebarOpen ? "open" : ""}`}>
        <div className="sidebar__logo">
          <img src={Logo} alt="" />
        </div>
        <div className="dashboard-sidebar__menu">
          <ul className="sidebar__menu-list">
            <NavLink to="/systemprompt"
              className={`sidebar__menu-item ${
                activePath === "/systemprompt" ? "active" : ""
              }`}
            >
              <img
                src={activePath === "/systemprompt" ? SystemActive : SystemPic}
                alt=""
              />

              <div
              className={` ${
                activePath === "/systemprompt" ? "sidebar__menu-link active" : "sidebar__menu-link"
              }`}
                
              >
                System Prompt
              </div>
            </NavLink>
            <NavLink  to="/allresp"
              className={`sidebar__menu-item ${
                activePath === "/allresp" ? "active" : ""
              }`}
            >
              <img
                src={activePath === "/allresp" ? AllRespActive : AllResp}
                alt=""
              />

              <div
               
               className={` ${
                activePath === "/allresp" ? "sidebar__menu-link active" : "sidebar__menu-link"
              }`}
              >
                All Responses
              </div>
            </NavLink>
            <NavLink to="/users"
              className={`sidebar__menu-item ${
                activePath === "/users" ? "active" : ""
              }`}
            >
              <img
                src={activePath === "/users" ? userActiveIcon : UserIcon}
                alt=""
              />

              <div
               className={` ${
                activePath === "/users" ? "sidebar__menu-link active" : "sidebar__menu-link"
              }`}
              >
               Users
              </div>
            </NavLink>
          </ul>
          <div className="styled-line"></div>

<ul className="sidebar__menu-list">
<NavLink to="/about-us"
              className={`sidebar__menu-item ${
                activePath === "/about-us" ? "active" : ""
              }`}
            >
              <img
                src={activePath === "/about-us" ? aboutActiveIcon : aboutIcon}
                alt=""
              />

              <div
                className={` ${
                  activePath === "/about-us" ? "sidebar__menu-link active" : "sidebar__menu-link"
                }`}
               
              >
               About Us
              </div>
            </NavLink>
<NavLink   to="/contact"
              className={`sidebar__menu-item ${
                activePath === "/contact" ? "active" : ""
              }`}
            >
              <img
                src={activePath === "/contact" ? contactActiveIcon:contactIcon  }
                alt=""
              />

              <div
              
              className={` ${
                activePath === "/contact" ? "sidebar__menu-link active" : "sidebar__menu-link"
              }`}
              >
               Contact Us
              </div>
            </NavLink>
            
            <NavLink to="/privacy-policy"
              className={`sidebar__menu-item ${
                activePath === "/privacy-policy" ? "active" : ""
              }`}
            >
              <img
                src={activePath === "/privacy-policy" ?  privacyActiveIcon: privacyIcon}
                alt=""
              />

              <div
                
                className={` ${
                  activePath === "/privacy-policy" ? "sidebar__menu-link active" : "sidebar__menu-link"
                }`}
              >
               Privacy Policy
              </div>
            </NavLink>
            <NavLink to="/terms-and-conditions"
              className={`sidebar__menu-item ${
                activePath === "/terms-and-conditions" ? "active" : ""
              }`}
            >
              <img
                src={activePath === "/terms-and-conditions" ? termsActiveIcon : termsIcon}
                alt=""
              />

              <div
                
                className={` ${
                  activePath === "/terms-and-conditions" ? "sidebar__menu-link active" : "sidebar__menu-link"
                }`}
              >
              Terms and Conditions
              </div>
            </NavLink>
</ul>
          <div className="styled-line"></div>

          <ul className="sidebar__menu-list">
            <li
              style={{ cursor: "pointer" }}
              className={`sidebar__menu-item ${
                activePath === "" ? "active" : ""
              }`}
              onClick={logoutfunc}
            >
              <Icon
                icon="material-symbols:logout"
                width={20}
                height={20}
                color="#64748b"
              />
              <NavLink
                href="#"
                className={({ isActive }) =>
                  isActive ? "sidebar__menu-link" : "sidebar__menu-link active"
                }
              >
                Logout
              </NavLink>
              
            </li>
          </ul>
        </div>
      </div>
      <button className="toggle-sidebar" onClick={toggleSidebar}>
        <Hamburger color="black" />
      </button>
      <div className="w-100 dashboard-childrens">
        {/* {isSidebarOpen && */}

        {/* } */}
        {children}
      </div>
    </div>
  );
};

export default DashboardSideBar;
